export default "__VITE_ASSET__DAgpFKq8__"